import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_home_accents: FaireCategoryEntity = {
  token: "catalog_cat_home-accents",
  type: "category",
  name: "Home accents",
  count: 1813,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
